module.exports = __webpack_public_path__ + "static/media/image-2.cf57ae35.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/FBGroup/image-2.png
// module id = 459
// module chunks = 0